<template>
	<div>
		<v-expansion-panels v-model="abrirPainelDotacoes" multiple flat>
			<v-expansion-panel class="my-2" active-class="aberto" flat>
				<v-expansion-panel-header class="collapse-selecionados-header" ripple>
					<v-row>
						<h4 class="mr-1">Dotação Orçamentária</h4>
						<label-personalizado
							nome-campo=""
							:obrigatorio-por-padrao="isDotacaoObrigatoria"
						></label-personalizado>
					</v-row>
				</v-expansion-panel-header>
				<v-expansion-panel-content class="collapse-selecionados-conteudo">
					<div class="pb-4">
						<div class="informations-expansion mb-4 mt-2" v-if="items.length > 0">
							<botao-primario
								nome-botao="ADICIONAR DOTAÇÃO"
								icone="add_circle"
								v-if="podeRealizarAcoesBotao"
								v-az-auth="permissoes.pedidoUtizacaoDotacaoOrcamentariaCriar"
								@click="abrirOuFecharModalIncluirDotacao"
							></botao-primario>
							<v-spacer></v-spacer>
							<span><b>Valor Total:</b> {{ valorTotalEstimado }}</span>
						</div>
						<template-listagem-vazia
							:textos="texto"
							:total-itens="totalItens"
							:botao="podeRealizarAcoesBotao ? botao : null"
							:permissao="permissoes.pedidoUtizacaoDotacaoOrcamentariaCriar"
							@botao-evento="abrirOuFecharModalIncluirDotacao"
						></template-listagem-vazia>
						<v-data-table
							v-if="items.length > 0"
							:items="items"
							:headers="colunas"
							:items-per-page="paginacaoInterna.rowsPerPage"
							:page="paginacaoInterna.page"
							hide-default-footer
							disable-pagination
							no-data-text=""
						>
							<template #item.anoExercicio="{ item }">
								<v-tooltip top>
									<template #activator="{ on, attrs }">
										<span v-bind="attrs" v-on="on">{{ item.anoExercicio }}</span>
									</template>
									<span>{{ item.anoExercicio }}</span>
								</v-tooltip>
							</template>
							<template #item.numeroReserva="{ item }">
								<v-tooltip top>
									<template #activator="{ on, attrs }">
										<span v-bind="attrs" v-on="on">{{ item.numeroReserva }}</span>
									</template>
									<span>{{ item.numeroReserva }}</span>
								</v-tooltip>
							</template>
							<template #item.funcaoProgramatica="{ item }">
								<v-tooltip top>
									<template #activator="{ on, attrs }">
										<span v-bind="attrs" v-on="on">{{ item.funcaoProgramatica.codigo }}</span>
									</template>
									<span class="description-limitation">{{ item.funcaoProgramatica.codigo }}</span>
								</v-tooltip>
							</template>
							<template #item.elementoSubelemento="{ item }">
								<v-tooltip top>
									<template #activator="{ on, attrs }">
										<span v-bind="attrs" v-on="on">{{
											`${item.elementoSubelemento.codigo} - ${item.elementoSubelemento.descricao}`
										}}</span>
									</template>
									<span class="description-limitation">{{
										`${item.elementoSubelemento.codigo} - ${item.elementoSubelemento.descricao}`
									}}</span>
								</v-tooltip>
							</template>
							<template #item.fonteRecursoFinanceiro="{ item }">
								<v-tooltip top>
									<template #activator="{ on, attrs }">
										<span v-bind="attrs" v-on="on">{{ item.fonteRecursoFinanceiro.codigo }}</span>
									</template>
									<span class="description-limitation">{{ item.fonteRecursoFinanceiro.codigo }}</span>
								</v-tooltip>
							</template>
							<template #item.valor="{ item }">
								<div v-if="!item.isEditarValor && item.valor !== null">
									<span>
										R$ {{ item.valor | rpCurrencyFilter('', numeroCasasDecimaisValores) }}
									</span>
									<v-icon
										color="primary"
										small
										@click="habilitarEdicaoValorItem(item)"
										v-if="podeRealizarAcoesBotao"
										v-az-auth="permissoes.pedidoUtizacaoDotacaoOrcamentariaEditar"
									>
										mdi-pencil
									</v-icon>
								</div>
								<div class="d-flex" v-else>
									<v-text-field
										v-if="!podeRealizarAcoesBotao"
										:disabled="true"
										label="R$ 0,00"
									></v-text-field>
									<az-money
										v-if="podeRealizarAcoesBotao"
										v-model="item._valor"
										:name="`Valor-${item.valor}`"
										:precision="numeroCasasDecimaisValores"
										placeholder="Informe"
										prefix="R$ "
										class="cell-editable"
										dense
									>
									</az-money>
									<v-icon
										v-if="podeRealizarAcoesBotao"
										class="material-icons btn-icon__editar-item-az-money"
										color="primary"
										size="15"
										@click="editarValorItem(item)"
									>
										mdi-check
									</v-icon>
								</div>
							</template>
							<template #item.acoes="{ item }">
								<div class="button-css-exclude">
									<v-icon
										color="grey"
										v-if="podeRealizarAcoesBotao"
										v-az-auth="permissoes.pedidoUtizacaoDotacaoOrcamentariaExcluir"
										@click="abrirModalConfirmacaoExclusao(item)"
									>
										mdi-delete
									</v-icon>
								</div>
							</template>
							<template #no-data></template>
						</v-data-table>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
		<modal-confirmacao
			id="excluirItemPedido"
			:exibir="exibirModalExclusaoItem"
			@fechar-modal="exibirModalExclusaoItem = false"
			@confirmar="excluirItem"
			:subtituloModal="subtituloModalExclusao"
			:tituloModal="tituloModalexclusao"
			:mensagem="mensagemModalExclusao"
		></modal-confirmacao>
		<modal-incluir-dotacao-orcamentaria
			v-if="exibirModalIncluir"
			:idPedido="infoPedido.id"
			:exibir-modal="exibirModalIncluir"
			:titulo-modal="tituloModalIncluirDotacao"
			@buscar-dotacoes="$emit('recarregar-dotacoes')"
			@fechar-modal="abrirOuFecharModalIncluirDotacao"
		></modal-incluir-dotacao-orcamentaria>
	</div>
</template>
<script>
import tabela from '@/views/mixins/tabela'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, situacoes } from '@/core/constants'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import ModalIncluirDotacaoOrcamentaria from '@/views/pages/pedido/acessar/itens/listagem-dotacao-orcamentaria/incluir-dotacao-orcamentaria/ModalIncluirDotacaoOrcamentaria.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'listagem-collapses-dotacao-orcamentaria',
	components: {
		LabelPersonalizado,
		ModalIncluirDotacaoOrcamentaria,
		BotaoPrimario,
		ModalConfirmacao,
		TemplateListagemVazia,
	},
	mixins: [tabela, arpBpmMixin, validacaoPedido],
	inject: ['idPedido', 'isEditar'],
	props: {
		infoPedido: {
			type: Object,
			required: true,
		},
		items: {
			type: Array,
			default: () => [],
		},
		valorTotalEstimado: {
			type: Number,
			default: 0,
		},
	},
	emits: ['paginar', 'recarregar-dotacoes'],
	data() {
		return {
			paginacaoInterna: this.paginacao,
			exibirModalIncluir: false,
			tituloModalIncluirDotacao: 'Seleção de Dotação Orçamentária',
			isDotacaoObrigatoria: this.$store.state.parametrosSistema.dotacaoObrigatoria,
			itemParaExcluir: {},
			isEditarValor: false,
			exibirModalExclusaoItem: false,
			abrirPainelDotacoes: [0],
			mensagemModalExclusao: 'Ao confirmar a ação, a dotação será excluída definitivamente!',
			subtituloModalExclusao: 'Deseja realmente excluir?',
			tituloModalexclusao: 'Excluir',
			botao: {
				nome: 'INCLUIR DOTAÇÃO',
				icone: 'mdi-plus-circle',
			},
			texto: {
				mensagem: 'Você não possui <b>dotações orçamentárias</b> adicionadas. Clique no botão para começar.',
			},
		}
	},
	computed: {
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.pedido.numeroCasasDecimaisValores
			},
		},
		colunas() {
			return this.getColunasTabela()
		},
		podeRealizarAcoesBotao() {
			return (
				(this.hasAuthority || this.estaEmRascunho(this.infoPedido)) &&
				!this.estaEmSituacaoOndeItemNaoPodeSerAlterado(this.infoPedido) &&
				!this.isAtaCancelada
			)
		},
		isAtaCancelada() {
			return this.infoPedido.ataRegistroPreco?.situacao === situacoes.ATA.CANCELADO.value
		},
	},
	async created() {
		await this.carregarInstancia(`${this.idPedido}`)
	},
	methods: {
		habilitarEdicaoValorItem(item) {
			item.isEditarValor = true
		},
		async editarValorItem(item) {
			if (this.podeEditarItem(item)) {
				try {
					item.valor = item._valor
					await this.$store.dispatch(actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.EDITAR_VALOR_DOTACAO, {
						idDotacao: item.id,
						valor: item.valor,
					})
					await this.$emit('recarregar-dotacoes')
					this.mostrarNotificacaoSucesso('Dotação Orçamentária alterada com sucesso.')
					item.isEditarValor = false
				} catch (Err) {
					item._valor = item.valor
					throw new Error(Err)
				}
			} else this.mostrarNotificacaoErro('Insira um valor para a dotação antes de confirmar!')

			this.isEditarValor = false
		},
		podeEditarItem(item) {
			return item._valor && item._valor > 0
		},
		abrirModalConfirmacaoExclusao(item) {
			this.itemParaExcluir = item.id
			this.exibirModalExclusaoItem = true
		},
		async excluirItem() {
			await this.$store.dispatch(actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.EXCLUIR_DOTACAO, this.itemParaExcluir)
			await this.$emit('recarregar-dotacoes')
			this.mostrarNotificacaoSucesso('Dotação excluída do pedido com sucesso!')
			this.exibirModalExclusaoItem = false
		},
		getColunasTabela() {
			const colunas = []

			colunas.push(new TabelaColunaUtils('Exercício', 'anoExercicio', '10%', 'left'))
			colunas.push(new TabelaColunaUtils('N° Pré-Empenho Reserva', 'numeroReserva', '12%', 'left'))
			colunas.push(new TabelaColunaUtils('Função Programática', 'funcaoProgramatica', '20%', 'left'))
			colunas.push(new TabelaColunaUtils('Elemento/Sub', 'elementoSubelemento', '22%', 'left'))
			colunas.push(new TabelaColunaUtils('Fonte Recurso', 'fonteRecursoFinanceiro', '', 'left'))
			colunas.push(new TabelaColunaUtils('Valor', 'valor', '15%', 'left'))

			if (this.podeRealizarAcoesBotao) {
				colunas.push(new TabelaColunaUtils('Ações', 'acoes', '5%'))
			}

			return colunas
		},
		abrirOuFecharModalIncluirDotacao() {
			this.exibirModalIncluir = !this.exibirModalIncluir
		},
	},
}
</script>
<style scoped lang="stylus">
.description-limitation
	text-overflow: ellipsis;
	overflow: hidden;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	display: block;
	display: -webkit-box;
	max-height: 48px;

estilo-padrao()
	border .1rem solid var(--v-grey-lighten1)
	border-radius .3rem

.v-expansion-panel--active.aberto > .v-expansion-panel-header
	min-height auto

.aberto .collapse-selecionados-header
	border-bottom-left-radius 0
	border-bottom-right-radius 0

.aberto .collapse-selecionados-conteudo
	border-top-color transparent
	border-top-left-radius 0
	border-top-right-radius 0

.collapse-selecionados-header
	background-color var(--v-grey-lighten4)
	color var(--v-grey-darken1)
	estilo-padrao()

.collapse-selecionados-conteudo
	estilo-padrao()
	padding-top: .5%;

.informations-expansion
	display: flex;
	align-items: center;

.button-css-exclude
	display: flex
	justify-content: center
</style>
